<template>
  <div class="w-full">
    <div
      class="!rounded-t-lg bg-[#009A78] text-white 
             text-xl 4xl:text-[28px] 5xl:text-[36px] 
             font-semibold p-4 4xl:p-6 5xl:p-8 
             text-center"
    >
      {{ mode === "edit" ? "Edit Holidays" : "Add New Holidays" }}
    </div>

    <div class="p-6 md:p-10 4xl:p-14 5xl:p-20 flex flex-col gap-5 4xl:gap-7 5xl:gap-10">
      <form autocomplete="off" class="flex flex-col gap-3 4xl:gap-5 5xl:gap-7">
        <div>
          <label 
            class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                   mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
            for="holidays-name"
          >
            Holidays Name
          </label>
          <input
            class="w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                   p-3 4xl:p-5 5xl:p-6 
                   !rounded-lg bg-[#F0F0F0] border border-gray-300 
                   focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] 
                   transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                   text-[#000000] font-normal placeholder:text-[#9B9A9A]"
            autocomplete="off"
            id="holidays-name"
            type="text"
            v-model="holidaysName"
            placeholder="e.g., Hari Raya Puasa"
          />
        </div>

        <div>
          <label 
            class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                   mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
            for="dateRange"
          >
            Start & End Date
          </label>
          <Datepicker
            class="datepicker-custom w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                   !rounded-lg bg-[#F0F0F0] text-[#000000] font-normal text-base 4xl:!text-[22px] 5xl:!text-[30px]"
            id="dateRange"
            v-model="dateRange"
            @update:model-value="handleDate"
            :enable-time-picker="false"
            :format="formatDateRange"
            range
            placeholder="Select date"
          ></Datepicker>
        </div>

        <div class="relative">
          <label 
            class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                   mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
            for="status-dropdown-btn"
          >
            Holidays Status
          </label>
          <button
            class="w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                   px-4 4xl:px-6 5xl:px-8 
                   !rounded-lg bg-[#F0F0F0] text-left 
                   flex justify-between items-center 
                   border border-white transition text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                   font-normal hover:!border-[#218863] placeholder:text-[#9B9A9A]"
            :class="[status ? 'text-[#000000]' : 'text-[#9B9A9A]']"
            type="button"
            @click="showStatusDropdown = !showStatusDropdown"
            id="status-dropdown-btn"
          >
            <span>
              {{ status === "" ? "Select Status" : status }}
            </span>
            <svg
              class="w-4 h-4 4xl:w-6 4xl:h-6 5xl:w-8 5xl:h-8 ml-2 text-[#009A78] transition-transform duration-200"
              :class="{ 'rotate-180': showStatusDropdown }"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
            </svg>
          </button>
          <div
            v-if="showStatusDropdown"
            class="absolute right-0 mt-2 w-full bg-[#009a78] border !rounded-lg shadow-2xl z-20 "
          >
            <a
              v-for="option in statusOptions"
              :key="option"
              class="block whitespace-nowrap !px-6 !py-4 4xl:!py-5 5xl:!py-7 
                     !text-[16px] 4xl:!text-[20px] 5xl:!text-[30px] 
                     text-center text-white cursor-pointer hover:!bg-[#DADADA]"
              :class="{ 'border-l-4 4xl:!border-l-5 5xl:!border-l-7 border-[#DADADA]': option === status }"
              @click="selectStatus(option)"
            >
              {{ option }}
            </a>
          </div>
        </div>
      </form>
    </div>

    <div
      class="p-6 md:p-10 4xl:p-14 5xl:p-20 
             flex flex-col gap-5 4xl:gap-7 5xl:gap-9 
             border-t border-gray-200 !rounded-b-lg"
    >
      <button
        class="w-full h-[51px] 4xl:!h-[72px] 5xl:!h-[104px] 
               !rounded-lg 5xl:!rounded-2xl bg-[#009A78] text-white 
               text-base 4xl:!text-[22px] 5xl:!text-[30px] 
               font-normal hover:bg-[#00795e] transition duration-200"
        type="button"
        @click="handleSave"
      >
        Save
      </button>

      <button
        v-show="mode === 'edit'"
        class="w-full h-[51px] 4xl:!h-[72px] 5xl:!h-[104px] 
               !rounded-lg 5xl:!rounded-2xl bg-[#FF9700] text-white 
               text-base 4xl:!text-[22px] 5xl:!text-[30px] 
               font-normal hover:bg-[#cc7a00] transition duration-200"
        type="button"
        @click="handleDelete"
      >
        Delete
      </button>
    </div>
  </div>
</template>

<script>
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";

export default {
  components: {
    Datepicker,
  },
  props: ["isEdit", "formEdit"],
  emits: ["closeModal", "onDelete", "onSave"],
  data() {
    return {
      mode: "add",
      dateRange: [],
      holidaysName: "",
      status: "",
      holidayID: "",
      statusOptions: ["Active", "Disabled"],
      showStatusDropdown: false,
    };
  },
  methods: {
    getDisplayStatus(statusValue) {
      if (statusValue === null || statusValue === undefined) return "";
      const val = String(statusValue).toLowerCase().trim();
      if (val === "active" || val === "1" || val === "on" || val === "t" || val === "true") {
        return "Active";
      }
      return "Disabled";
    },
    selectStatus(option) {
      this.status = option;
      this.showStatusDropdown = false;
    },
    handleDate() {},
    formatDateRange(dateRange) {
      if (Array.isArray(dateRange) && dateRange.length === 2) {
        return dateRange.map(date => moment(date).format("DD / MM / YYYY")).join(" - ");
      }
      return "";
    },
    resetForm() {
      this.holidaysName = "";
      this.dateRange = [];
      this.status = "";
      this.holidayID = "";
      this.showStatusDropdown = false;
    },
    handleSave() {
      if (!this.holidaysName || this.dateRange.length !== 2 || !this.status) {
        alert("Please fill in Holidays Name, Start & End Date, and Status."); 
        return;
      }
      const payload = {
        HolidayName: this.holidaysName,
        StartDate: moment(this.dateRange[0]).format("YYYY-MM-DD"), 
        EndDate: moment(this.dateRange[1]).format("YYYY-MM-DD"),
        Status: this.status, 
        ClusterID: this.$parent.clusterSelected?.value || null,
      };
      console.log("Payload to API:", payload);
      this.$emit("onSave", payload, this.mode === "edit" ? this.holidayID : "");
      this.$nextTick(() => {
        this.closeModal();
      });
    },
    handleDelete() {
      this.$emit("onDelete", this.holidayID);
      this.closeModal();
    },
    closeModal() {
      this.resetForm();
      this.$emit("closeModal");
    },
  },
  watch: {
    isEdit: {
      handler(val) {
        this.mode = val ? "edit" : "add";
        this.holidaysName = val ? this.formEdit.holidaysName : "";
        this.holidayID = val ? this.formEdit.holidayID : "";
        this.status = val ? this.getDisplayStatus(this.formEdit.status) : "";
        if (val && this.formEdit.startDate && this.formEdit.endDate) {
          const start = new Date(moment(this.formEdit.startDate).format("YYYY-MM-DD"));
          const end = new Date(moment(this.formEdit.endDate).format("YYYY-MM-DD"));
          this.dateRange = [start, end];
        } else {
          this.dateRange = [];
        }
      },
      immediate: true,
    },
    formEdit(val) {
      if (this.isEdit && val) {
        this.mode = "edit";
        this.holidaysName = val.holidaysName;
        this.status = this.getDisplayStatus(val.status); 
        this.holidayID = val.holidayID;
        this.dateRange = [
          new Date(moment(val.startDate).format("YYYY-MM-DD")),
          new Date(moment(val.endDate).format("YYYY-MM-DD")),
        ];
      }
    },
  },
};
</script>

<style lang="scss">
  #status-dropdown-btn {
    padding: 0rem 1rem !important;
  }

.datepicker-custom {
  .dp__input_wrap {
    height: 100%;
  }
  .dp__input {
    height: 100%;
    border: none;
    border-radius: 8px;
    background: #f0f0f0;
    color: #000000 !important;
    font-weight: 400 !important;
    font-size: 16px;
    padding: 1rem 2.5rem;
    font-family: inherit;
    &::placeholder {
      color: #9b9a9a !important;
      font-weight: 400 !important;
    }
  }
  .dp__input:focus {
    box-shadow: 0 0 0 1px #3b82f6 !important;
    border-color: #3b82f6 !important;
    outline: none;
  }
  .dp__menu {
    font-family: inherit;
    color: #000000;
  }
  .dp__instance_calendar,
  .dp__select,
  .dp__calendar_header_item,
  .dp__month_year_select,
  .dp__pointer,
  .dp__calendar_item {
    color: #000000 !important;
  }
}

@media (min-width: 2560px) {
  .datepicker-custom {
    .dp__input {
      font-size: 22px !important;
      padding: 1.2rem 2.5rem !important;
    }
  }
  .datepicker-custom {
    .dp__input_icon {
      width: 20px !important;
      height: 20px !important;
    }
  }
  .dp__menu {
    font-size: 20px !important;
    transform: scale(1.15);
    transform-origin: top center;
    width: 326px !important;
  }
  .dp__calendar,
  .dp__calendar_header,
  .dp__month_year_select {
    font-size: 20px !important;
  }
  .dp__cell_inner {
    padding: 1rem !important;
  }

  button.absolute.top-3.right-3.text-gray-500 {
    top: 1.5rem !important;
    right: 1.5rem !important;

    svg {
      width: 32px !important;
      height: 32px !important;
    }
  }
}

@media (min-width: 3840px) {
  .datepicker-custom {
    .dp__input {
      font-size: 30px !important;
      padding: 1.8rem 4.6rem !important;
    }
  }
  .datepicker-custom {
    .dp__input_icon {
      width: 26px !important;
      height: 26px !important;
      padding: 24px 32px !important;
    }
  }
  .dp__menu {
    font-size: 28px !important;
    transform: scale(1.3);
    transform-origin: top center;
    width: 436px !important;
  }
  .dp__calendar,
  .dp__calendar_header,
  .dp__month_year_select {
    font-size: 28px !important;
  }
  .dp__cell_inner {
    padding: 1.2rem !important;
  }

  #holidays-name {
    padding: 2.8rem 1.125rem !important;
    font-size: 30px !important; /* To match the font size as well */
    border-radius: 18px !important;
  }

  /* 🎯 NEW RULE: Targets the Status Dropdown button for consistent padding */
  #status-dropdown-btn {
    padding: 2.8rem 2rem !important;
    font-size: 30px !important; 
    border-radius: 18px !important;
  }

  button.absolute.top-3.right-3.text-gray-500 {
    top: 2rem !important;
    right: 2rem !important;

    svg {
      width: 44px !important;
      height: 44px !important;
    }
  }
}
</style>
